export default __webpack_public_path__ + "static/media/bee.0cc692d5.svg";